<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div class="px-10 pt-12 pb-4">
      <div class="-m-3 flex flex-wrap items-center pt-10">
        <div class="w-6/12 shrink-0 p-3">
          <div
            class="relative h-full overflow-hidden rounded-[10px] border-4 border-white bg-white pt-0"
          >
            <img
              :src="latestNews?.imagePathAndName || defaultNewsImg"
              class="block w-full"
              alt=""
            >
          </div>
        </div>

        <div class="w-6/12 shrink-0 p-3">
          <div
            class="relative overflow-hidden rounded-[10px] border-4 border-white bg-white"
          >
            <div
              class="truncate px-4 pt-8 pb-2 text-xl font-medium tracking-[0.0125em]"
            >
              <div class="px-8 pt-1 pb-2 text-4xl font-normal">
                {{ formattedDate(latestNews?.publishDate) }} |
                {{ latestNews?.category }}
              </div>
            </div>
            <div class="px-8 pt-10 pb-4 text-5xl leading-[1.3]">
              {{ latestNews?.headline }}
            </div>
            <div class="px-8 pt-4 pb-4 text-4xl leading-[1.3] font-normal">
              {{ bodyText }}...
            </div>
            <div class="flex min-h-13 items-center gap-2 p-2">
              <QRCode :url="url" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  article: {
    type: Object as PropType<INewsArticle | undefined>,
    required: true,
  },
});
const latestNews = computed(() => props.article);

const htmlBody = computed(() => latestNews.value?.body ?? '<div />');
const url = computed(() => latestNews.value?.url ?? '');

const { theme } = useBrandTheme();
const defaultNewsImg = computed(() => theme.value.assets.defaultNewsImg);

function stripHtml(html: string) {
  if (typeof document === 'undefined') return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

function formattedDate(date: string | Date | undefined) {
  if (typeof date === 'undefined') return '';
  const formatDate = new Date(date);
  return `${formatDate.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}`;
}

const characterLimit = 200;
const bodyText = computed(() =>
  stripHtml(htmlBody.value).substring(0, characterLimit)
);
</script>

<style>
#qr_code_canvas {
  width: 220px !important;
  height: 220px !important;
}
</style>
